import { GQLResponsePerimeterXChallengeError } from '@change-corgi/core/gql';
import { useTracking } from '@change-corgi/core/react/tracking';

import { useCreateMembership, usePreparePaymentMethod } from '../../../../../../../hooks';
import { useMembershipModalState } from '../../../../../../../modalContext';
import { isUserAlreadyACustomerError } from '../../../../../../../shared';
import type { ModalCallbackProps } from '../../../../../../../shared/types';

export function useSubmit({ onAccept, onDecline }: ModalCallbackProps): () => Promise<void> {
	const track = useTracking();

	const [, { setLoading, clearLoading }] = useMembershipModalState();
	const preparePaymentMethod = usePreparePaymentMethod();
	const createMembership = useCreateMembership();

	return async function submit() {
		void track('membership_ask_slide_up_submit');

		setLoading();
		try {
			await preparePaymentMethod();
			await createMembership();
			void track('subs_modal_success', {
				source_location: 'post_promote',
			});
			void track('membership_ask_slide_up_success');
			clearLoading();
			onAccept();
		} catch (error) {
			if (isUserAlreadyACustomerError(error)) {
				onDecline();
				return;
			}
			/*
				If PerimeterX error is thrown in PPMU flow, we are not able to currently display the challenge modal
				on top of PPMU modal. For now, it tracks the error event, closes the modal and takes users to promote thank you page
				*/
			if (error instanceof GQLResponsePerimeterXChallengeError) {
				void track('membership_ask_slide_up_failure', {
					source_location: 'membership_ask_slide_up',
					errorMessage: 'Human verification required',
				});
				onDecline();
			} else
				void track('membership_ask_slide_up_failure', {
					error_message: (error as Error).message || 'Unknown error',
				});
		}
	};
}
